"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerFacingBomItemStaticMetadataSchema = void 0;
const zod_1 = require("zod");
exports.customerFacingBomItemStaticMetadataSchema = zod_1.z.object({
    referenceDesignator: zod_1.z.string(),
    isCadstromReviewed: zod_1.z.boolean(),
    value: zod_1.z.string().nullable(),
    numComponentPins: zod_1.z.number().int().nonnegative(),
    numComponentSignals: zod_1.z.number().int().nonnegative(),
    isVirtual: zod_1.z.boolean(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.null()])),
});
//# sourceMappingURL=customer-facing-bom-item.js.map